import React from "react";
import { AppLink } from "../../../components/ui/link";
import type { RouteMap } from "../types";

type LegalFooterProps = {
  routes: RouteMap;
};

export const LegalFooter: React.FC<LegalFooterProps> = ({ routes }) => (
  <footer className="mt-16 border-t border-border bg-muted/30">
    <div className="mx-auto max-w-3xl px-4 py-8">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <p className="text-sm text-muted-foreground">
          <span suppressHydrationWarning>
            &copy; {new Date().getFullYear()} ToolKit. All rights reserved.
          </span>
        </p>
        <div className="flex gap-6 text-sm font-medium">
          <AppLink to={routes.terms} variant="muted">
            Terms of Service
          </AppLink>
          <AppLink to={routes.privacy} variant="muted">
            Privacy Policy
          </AppLink>
          <AppLink to={routes.faq} variant="muted">
            FAQ
          </AppLink>
        </div>
      </div>
    </div>
  </footer>
);
